import { CapturePDFButton } from '@/components/Buttons/CapturePDFButton';
import { DownloadButton } from '@/components/Buttons/DownloadButton';
import InfoTooltip from '@/components/Tooltip/InfoTooltip';
import { ReactNode } from 'react';

interface IProps {
  label?: string;
  disabled?: boolean;
  tooltipValue?: ReactNode;
  onDownload?: () => void;
  onPrint?: () => void;
}

const CardHeader = ({ disabled, label, tooltipValue, onDownload, onPrint }: IProps) => {
  return (
    <div className='flex justify-between'>
      <div className='flex items-center gap-2 relative'>
        <div className='text-lg text-[#2E2C34] font-semibold'>{label}</div>
        {tooltipValue && <InfoTooltip className='right-[-17px] top-[-10px]' maxWidth={450} title={tooltipValue} />}
      </div>
      <div className='space-x-[6px] flex-row flex'>
        {onDownload ? <DownloadButton disabled={disabled} onClick={onDownload} /> : null}
        {onPrint ? <CapturePDFButton disabled={disabled} onClick={onPrint} /> : null}
      </div>
    </div>
  );
};

export default CardHeader;
